import type { ReactNode } from 'react';

import { Banner, type BannerVariant } from '@/lib/ui/molecules/Banner';
import { cn } from '@/lib/utils';

interface GlobalBannerProps {
  variant?: BannerVariant;
  className?: string;
  children: ReactNode;
}

// Generic, always-on-top banner for the app shell — pinned above the sidebar/content
// row so it never scrolls out of view. Callers decide when to render it and with what
// copy (dev sandbox notice today; a promo or seasonal banner could reuse this later).
export function GlobalBanner({ variant = 'info', className, children }: GlobalBannerProps) {
  return (
    <Banner variant={variant} className={cn('sticky top-0 z-30', className)}>
      {children}
    </Banner>
  );
}
